<template>
  <div class="payment">
    <AmList>
      <template v-for="payment in payments">
        <label
          :key="payment.title"
          class="label--custtom mb-0"
          :for="`am-radio-select-${payment.option.value}`"
        >
          <AmListItem>
            <template #append>
              <AmRadio
                :id="`select-${payment.option.value}`"
                v-model="paymentTypeSelected"
                data-test="select_payment"
                :class="theme.color"
                :option="payment.option"
                :name="payment.option.value"
                @change="paymentSelected()"
              />
            </template>
            <template #title>
              {{ payment.title }}
            </template>
            <template
              v-if="payment.option.value === 'card'"
              #subtitle
            >
              <img
                v-for="flag in cardFlags"
                :key="flag"
                class="payment__flags"
                :src="`/img/card-flags/${flag}.svg`"
                :alt="`${flag}`"
              />
            </template>
            <template
              v-else-if="payment.option.value === applePayKey"
              #subtitle
            >
              <img
                class="payment__flags"
                src="/img/wallet-flags/apple-pay.svg"
                alt="Apple Pay flag"
              />
            </template>
          </AmListItem>
        </label>
        <hr
          :key="`${payment.title}-hr`"
          class="payment__divider"
        />
      </template>
    </AmList>

    <div class="payment__coupon">
      <AmInput
        v-model="couponCodeModel"
        :test-name="'input_coupon'"
        :disabled="couponApplied"
        :class="['input--custom', { 'input--coupon-applied': couponApplied }]"
        :label="$t('steps.payment.couponDiscount.label')"
        :placeholder="$t('steps.payment.couponDiscount.placeholder')"
        :validity-state="statusCouponValidate"
        :secondary-label="textCouponValidate"
      >
        <template #right>
          <AmIconMaterial
            v-if="couponApplied"
            data-test="remove_coupon"
            name="delete_forever"
            size="lg"
            :class="[`text--${theme.color}`, 'payment__coupon__remove']"
            @click="postRemoveCoupon()"
          />
        </template>
      </AmInput>
      <AmButton
        v-if="!couponApplied"
        data-test="applier_coupon"
        :class="[theme.color, 'payment__coupon__applyer']"
        :label="$t('steps.payment.couponAppllier')"
        size="lg"
        @click="postApplyerCoupon()"
      />
    </div>
    <!--
      TODO: Esse trecho foi comentado pois não irá ser implementado nessa primeira versão.
     -->
    <!-- <div class="payment__save_data">
      <AmCheckbox
        v-model="saveData"
        data-test="save_data"
        :class="theme.color"
        :label="$t('steps.payment.saveData')"
      />
    </div> -->
  </div>
</template>

<script>
import AmList from '@/components/molecules/AmList.vue'
import AmListItem from '@/components/atoms/AmListItem.vue'
import queryPersistance from '@/components/mixins/queryPersistance'
import ApplePayConfigs from '@/utils/ApplePay/configs'
import themeMixin from '@/components/mixins/themeMixin'
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

export default {
  name: 'StepPayment',
  components: {
    AmList,
    AmListItem,
  },
  mixins: [themeMixin, queryPersistance],
  data() {
    return {
      applePayKey: ApplePayConfigs.key,
      couponCodeModel: '',
      cardFlags: ['visa', 'master-card', 'hiper-card', 'american-express', 'diners-club', 'elo'],
      saveData: true,
      paymentTypeSelected: null,
      statusCouponValidate: null,
      textCouponValidate: null,
      couponApplied: false,
      payments: [
        {
          title: this.$t('steps.payment.type.card'),
          option: {
            value: 'card',
          },
        },
        {
          title: this.$t('steps.payment.type.billet'),
          option: {
            value: 'billet',
          },
        },
        {
          title: this.$t('steps.payment.type.pix'),
          option: {
            value: 'pix',
          },
        },
      ],
    }
  },
  computed: {
    ...mapState('Checkout', {
      coupon_code: (state) => state.cart.coupon,
      payment_type: (state) => state.payment_type,
      settings: (state) => {
        return state.cart.settings
      },
    }),
    ...mapGetters('Cart', ['isInfoProduto']),
  },
  watch: {
    coupon_code: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue.code) {
          this.couponCodeModel = newValue.code
          this.couponApplied = true
          return true
        }

        this.couponCodeModel = ''
        this.couponApplied = false
        return false
      },
    },
    payment_type: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (!newValue) {
          this.paymentTypeSelected = 'card'
        }

        if (newValue && !this.settings.payments.includes(newValue)) {
          const [paymentDefaultConfig] = this.settings.payments
          this.paymentTypeSelected = paymentDefaultConfig
          this.paymentSelected()
          return
        }

        if (newValue && this.paymentTypeSelected !== newValue) {
          this.paymentTypeSelected = newValue
        }
      },
    },
    settings: {
      immediate: true,
      deep: true,
      handler() {
        if (this.settings) {
          this.formatPaymentsOptions()
        }
      },
    },
  },
  mounted() {
    this.SET_CURRENT_STEP(3)
  },
  methods: {
    ...mapMutations('Checkout', ['SET_PAYMENT_TYPE', 'SET_CURRENT_STEP']),
    ...mapActions('Checkout', ['applyerCoupon', 'removeCoupon']),
    ...mapActions('ApplePay', ['filterApplePayPayment']),
    previousStep() {
      const routerName = this.isInfoProduto ? 'new.dataStep' : 'new.stepReviewAddress'
      this.$router.push({ name: routerName, query: { pl: this.getPl?.pl } })
    },
    nextStep() {
      return new Promise((resolve) => {
        this.$router.push({
          name: `new.stepPayment-${this.paymentTypeSelected}`,
          params: { history: true },
          query: { pl: this.getPl?.pl },
        })
        resolve()
      })
    },
    paymentSelected() {
      this.SET_PAYMENT_TYPE(this.paymentTypeSelected)
      this.$emit('paymentSelected', this.paymentTypeSelected)
    },
    async postApplyerCoupon() {
      try {
        this.validateData()
        await this.applyerCoupon(this.couponCodeModel)
        this.statusCouponValidate = null
        this.textCouponValidate = null
      } catch (error) {
        const errorStatusCode = error.message

        if (errorStatusCode === '400') {
          this.statusCouponValidate = 'error'
          this.textCouponValidate = this.$t('steps.payment.couponInvalid')
        }

        throw new Error(error)
      }
    },
    async postRemoveCoupon() {
      try {
        this.validateData()
        await this.removeCoupon(this.couponCodeModel)
      } catch (error) {
        throw new Error(error)
      }
    },
    async formatPaymentsOptions() {
      this.payments = await this.filterApplePayPayment(
        this.settings.payments.map((payment) => {
          return {
            title: this.$t(`steps.payment.type.${payment}`),
            option: {
              value: payment,
            },
          }
        })
      )
    },
    validateData() {
      const validCoupon = this.validateCoupon()

      if (validCoupon) {
        return true
      }
      throw new Error(false)
    },
    validateCoupon() {
      if (!this.couponCodeModel) {
        return false
      }

      this.statusCouponValidate = null
      this.textCouponValidate = ''

      return true
    },
  },
}
</script>

<style lang="scss" scoped>
.payment {
  width: 100%;
  height: auto;

  &__coupon {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    .input--custom {
      width: 100%;
      margin: 0;
    }

    .input--coupon-applied {
      ::v-deep {
        .input-container {
          input {
            opacity: 1;
            background: rgba($blue, 0.2);
            border-color: rgba($blue, 0.8);
            color: rgba($blue, 0.8);
            font-weight: 500;
          }
        }
      }
    }

    &__applyer {
      margin: 0 0 0 7px;
    }

    &__remove {
      pointer-events: all;
      cursor: pointer;
    }
  }

  &__save_data {
    margin: 25px 0 22px 0;
  }

  &__flags {
    margin: 0 8px 0 0;
  }

  &__divider {
    margin: 0;
  }

  &__divider:last-child {
    display: none;
  }

  .label--custtom {
    width: 100%;
  }
}
</style>
